import React, { useEffect, useState } from "react";
import LoginSignup from "./LoginSignup";
import { useSelector } from "react-redux";
import useAuth from "../header/useAuth";
import { trackButtonClick } from "@/utils/analytics";

const SubscribedUser = () => {
  const login = useSelector((state) => state.login);
  const { isUserLoggedIn } = useAuth();
  const [registered,setReistered] = useState(false);

  useEffect(() => {
    if (login.isUserSubscribed === false && isUserLoggedIn) {
     setReistered(true)
    }
  }, [login.isUserSubscribed]);

  useEffect(() => {
    const offcanvasElement = document.querySelector('.offcanvas');

    // Function to track when offcanvas is shown
    const handleOffcanvasShown = () => {
      trackButtonClick({
        eventName: `header_alerts_click`,
        eventCategory: "Global Alerts",
        eventLabel: "Status - Opened",
        eventSource: "Header - Alerts Open",
      });
    };

    // Function to track when offcanvas is hidden
    const handleOffcanvasHidden = () => {
      trackButtonClick({
        eventName: `header_alerts_click`,
        eventCategory: "Global Alerts",
        eventLabel: "Status - Closed",
        eventSource: "Header - Alerts close",
      });
    };

    // Event listeners for when offcanvas is shown and hidden
    if (offcanvasElement) {
      offcanvasElement.addEventListener(
        "shown.bs.offcanvas",
        handleOffcanvasShown
      );
      offcanvasElement.addEventListener(
        "hidden.bs.offcanvas",
        handleOffcanvasHidden
      );
    }

    // Cleanup function to remove event listeners when component unmounts
    return () => {
      if (offcanvasElement) {
        offcanvasElement.removeEventListener(
          "shown.bs.offcanvas",
          handleOffcanvasShown
        );
        offcanvasElement.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasHidden
        );
      }
    };
  }, []);

  return (
    <>
      <div className="offcanvas-header">
        <h2 id="subscribed-user-title" className="offcanvas-title saved-title">Complete Your Profile</h2>
        <button
          id="subscribed-user-close-btn"
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body p-2">
        <LoginSignup isFromAlerts={"Y"} isOtpVerificationModal={true}/>
        {/* {
         registered && <h2>Profile Completed</h2>
        } */}
      </div>
    </>
  );
};

export default SubscribedUser;
